import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Button, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import "firebase/firestore";
import _ from "lodash";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactToPrint from "react-to-print";
import { getOrders } from "../../api/restApi";
import CustomAutocomplete from "../../components/AutoComplete";
import OverlayLoader from "../../components/modals/OverlayLoader";
import Modal from "../../components/modals/ReportModal";
import i18n from "../../i18n/config";
import { ordersData } from "../../store/reducer/ordersSlice";
import { productsData } from "../../store/reducer/productsSlice";
import { ConvertOrderArrayToObject } from "../../utils/helpers";
import { useAppSelector } from "../../utils/hooks";
import CustomerAccordion from "./CustomerAccordion";
import TableColumnForPrint from "./TableColumnForPrint";

export default function Orders() {
  const isMediumScreen = useMediaQuery("(min-width: 960px)");
  const { t } = useTranslation();
  const [category, setCategory] = useState([]);
  const [orderByCustomer, setOrderByCustomer] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedRadiodValue, setSelectedRadioValue] = React.useState("a");
  const handleRadioChange = (event) => {
    setSelectedRadioValue(event.target.value);
  };
  const [productsInfo, setProductsInfo] = useState([]);
  const { products } = useAppSelector(productsData);
  const [open, setOpen] = React.useState(false);
  const [openLoader, setOpenLoader] = useState(true); // Set initial loader state to true
  const [seletedRow, setSeletedRow] = useState();
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const componentRef = useRef();
  const { ordersDate } = useAppSelector(ordersData);
  const [sortedOrdersDate, setSortedOrdersDate] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");

  useEffect(() => {
    // Get the current month and year
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();

    // Filter ordersDate to include only dates from the current month
    const currentMonthDates = ordersDate.filter(date => {
      const dateObj = new Date(date);
      
      const twoMonthsAgo = new Date();
      twoMonthsAgo.setMonth(currentMonth - 2);

      return true
    });

    // Sort filtered dates and set sortedOrdersDate
    const sortedDates = currentMonthDates.sort((a, b) => new Date(b) - new Date(a));
    setSortedOrdersDate(sortedDates);

    // Set default selectedDate to the latest date in the current month
    if (sortedDates.length > 0) {
      setSelectedDate(sortedDates[0]);
      callData(sortedDates[0]);
    }

    // Hide loader after fetching dates
    setOpenLoader(false);
  }, [ordersDate]);

  async function callData(date) {
    setOpenLoader(true);
    try {
      setCategory([]);
      setOrderByCustomer([]);
      setProductsInfo([]);
      let data = await getOrders(date);
      data = ConvertOrderArrayToObject(data);
      let orderType = [];
      let products = _.sortBy(data.orders_product, "id");
      products = products.map((pro) => {
        if (pro.id == undefined) {
          return;
        }
        return {
          ...pro,
          ...findProduct(pro.id),
        };
      });
      const groups =
        selectedRadiodValue === "a"
          ? _.groupBy(
              products,
              i18n.language === "ur" ? "category_urdu" : "category_english"
            )
          : _.groupBy(products, "recipe");
      Object.entries(groups).map(([key, value]) => {
        orderType.push(key);
      });
      setCategory([...orderType]);
      setOrderByCustomer([...data.orders_customer]);
      setProductsInfo(groups);

      if (orderType.length > 0) {
        setSelectedCategory(orderType[0]);
      }
      setOpenLoader(false);
    } catch {
      console.log("error");
      setOpenLoader(false);
    }
  }

  const arrayToChunk = (inputArray) => {
    inputArray.sort((a, b) => {
      const nameA = a.name_english.toLowerCase();
      const nameB = b.name_english.toLowerCase();

      if (
        (nameA.includes("single") || nameA.includes("cake-1lb")) &&
        !nameB.includes("single") &&
        !nameB.includes("cake-2lb")
      ) {
        return -1;
      } else if (
        !nameA.includes("single") &&
        !nameA.includes("cake-2lb") &&
        (nameB.includes("single") || nameB.includes("cake-1lb"))
      ) {
        return 1;
      } else {
        return 0;
      }
    });

    const result = inputArray.reduce((resultArray, item, index) => {
      const chunkIndex = Math.floor(index / 16);

      if (!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = []; // start a new chunk
      }

      resultArray[chunkIndex].push(item);
      return resultArray;
    }, []);

    return (
      <div style={{ width: "100%" }}>
        <Grid container justifyContent={"space-around"} direction={"row-reverse"}>
          {result.map((inputArray, index) => (
            <Grid key={index} borderWidth={1}>
              <TableColumnForPrint
                inputArray={inputArray}
                setSeletedRow={setSeletedRow}
                handleOpen={handleOpen}
                indexOffset={index * 16}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    );
  };

  const findProduct = (id) => {
    return products.find((el) => el.id.toString() === id.toString());
  };

  const handleSelectDate = async (event, newValue) => {
    setSelectedDate(newValue);
    setSelectedCategory();
    callData(newValue);
  };

  const handleSelectCategory = async (event, newValue) => {
    setSelectedCategory(newValue);
  };

  useEffect(() => {
    if (sortedOrdersDate.length > 0) {
      callData(sortedOrdersDate[0]);
    }
  }, [i18n.language, sortedOrdersDate]);

  return (
    <div>
      <Box>
        <Grid item xs={12} md={12}>
          <Card
            variant="outlined"
            sx={{
              minWidth: isMediumScreen ? "480px" : "300px",
              height: "90vh",
              overflow: "auto",
            }}
          >
            <CardContent style={{ textAlign: "center" }}>
              <ReactToPrint
                trigger={() => (
                  <Button
                    sx={{
                      marginBottom: 2,
                      height: "55px",
                      minWidth: isMediumScreen ? "500px" : "150px",
                    }}
                    variant="outlined"
                  >
                    {t("Print Daily Order Report out!")}
                  </Button>
                )}
                content={() => componentRef.current}
              />
              <Stack
                alignItems="center"
                spacing={4}
                direction="row"
                marginBottom="1rem"
                display={"flex"}
                justifyContent={"center"}
              >
                <CustomAutocomplete
                  id="combo-box-demo"
                  options={sortedOrdersDate}
                  value={selectedDate}
                  onChange={handleSelectDate}
                  label={t("Select Date")}
                />
                <CustomAutocomplete
                  id="combo-box-demo2"
                  options={category}
                  value={selectedCategory}
                  onChange={handleSelectCategory}
                  label={t("Select Category")}
                />
              </Stack>
              <div>
                <Stack
                  ref={componentRef}
                  direction={"row"}
                  justifyContent="center"
                  style={{ width: "100%" }}
                >
                  <div style={{ width: "100%" }}>
                    <Stack
                      justifyContent="center"
                      alignItems="center"
                      spacing={0}
                      direction={"row"}
                      marginBottom="1rem"
                    >
                      <Typography fontSize={"18px"} marginTop={"1rem"} textAlign={"end"}>
                        {selectedDate}
                      </Typography>
                    </Stack>
                    {productsInfo &&
                      productsInfo[selectedCategory] &&
                      arrayToChunk(productsInfo[selectedCategory])}
                  </div>
                </Stack>
              </div>
              {orderByCustomer.length > 0 && (
                <CustomerAccordion orderByCustomer={orderByCustomer} />
              )}
            </CardContent>
          </Card>
        </Grid>
      </Box>
      <Modal
        open={open}
        close={handleClose}
        orderByCustomer={orderByCustomer}
        row={seletedRow}
      />
      <OverlayLoader open={openLoader} />
    </div>
  );
}
